const importFromUrl = async <T>(url: string): Promise<T> => import(`${url}/dist/index.mjs`)

export {importFromUrl}
